import { SvgIcon } from '@material-ui/core'

export default function CursorIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M7.4072 2.48588C6.49088 1.87375 5.156 2.53249 5.25523 3.72392L5.28417 4.07142C5.7257 9.37299 6.65954 14.6252 8.07431 19.7643C8.41125 20.9882 10.1046 21.0937 10.6187 19.9593L12.7474 15.2623C12.9508 14.8132 13.445 14.525 13.9811 14.5824L19.2475 15.1464C20.4563 15.2759 21.3106 13.7999 20.3418 12.8647C16.4531 9.11045 12.2232 5.70313 7.7036 2.68389L7.4072 2.48588Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
